import { render, staticRenderFns } from "./ProjectDictionaryList.vue?vue&type=template&id=ebaf2960&"
import script from "./ProjectDictionaryList.vue?vue&type=script&lang=js&"
export * from "./ProjectDictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDictionaryList.vue?vue&type=style&index=0&id=ebaf2960&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports